import React from 'react';
import { FiHeart } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className="py-16 bg-white/30 dark:bg-zinc-950/30 backdrop-blur-xl border-t border-white/20 dark:border-zinc-800/30">
            <div className="container-custom">
                <div className="flex flex-col items-center text-center space-y-10">
                    {/* Quick Links */}
                    <nav className="flex flex-wrap justify-center gap-x-10 gap-y-5">
                        {[
                            { key: 'home', href: '#home' },
                            { key: 'about', href: '#about' },
                            { key: 'experience', href: '#experience' },
                            { key: 'projects', href: '#projects' },
                            { key: 'lab', href: '#homelab' },
                            { key: 'bots', href: '#bots' },
                            { key: 'ai', href: '#ai' },
                            { key: 'contact', href: '#contact' },
                        ].map(({ key, href }) => (
                            <a
                                key={key}
                                href={href}
                                className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 dark:text-zinc-500 hover:text-amber-600 dark:hover:text-amber-400 transition-colors transition-all hover:scale-110"
                            >
                                {t(`footer.${key}`)}
                            </a>
                        ))}
                    </nav>

                    {/* Divider */}
                    <div className="w-12 h-px bg-gradient-to-r from-transparent via-zinc-200 dark:via-zinc-800 to-transparent" />

                    {/* Copyright & Tech Stack */}
                    <div className="flex flex-col items-center space-y-4">
                        <div className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-amber-500/5 text-amber-600 dark:text-amber-400/80 border border-amber-500/10 text-[10px] uppercase font-bold tracking-widest">
                            {t('footer.madeWith')}
                            <FiHeart className="fill-current animate-pulse" />
                            {t('footer.andAI')}
                        </div>
                        <p className="font-mono text-[10px] text-zinc-400 dark:text-zinc-600 tracking-wider">
                            © 2026 RONTARO — ALL RIGHTS RESERVED
                        </p>
                    </div>
                </div>
            </div>
        </footer>


    );
};

export default Footer;
